import { Component, OnInit, ViewChild, HostListener } from '@angular/core'
import { AppConfigService } from './services/app-config-service/app-config.service'
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from './services/shell-update-service/shell-update.service';
import { MatSidenav, MatIconRegistry, MatSnackBar } from '@angular/material';
import { AuthHttpClient } from './services/auth-http-service/auth-http.service';
import { UserSessionService } from './services/user-session-service/user-session.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs/Subscription';
import { HomeCardService } from './services/home-card-service/home-card.service';
import { HomeCardModel } from './models/home-card-model';

////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     09/11/2017
// Description: Bootstrapped app component. Sets basic display info for the app and starts up
////-------------------------------------------------------------------------------------------

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  // Allows us to access a child view in the main view
  @ViewChild('sidenav') public sideNav: MatSidenav;
  appConfigService: any;

  // HostListener is used to hook into the documents object model (DOM)
  // We need to detect when the browser is closed so we can logout the user by deleting the token.
  @HostListener('window:beforeunload', ['$event'])
  onbeforeunload(ev: BeforeUnloadEvent) {
    // Delete the token, but don't attempt to logout via the logout call to CAS. The requests may not complete by the time the browser
    // Window is closed. The user will have to re-authenticate, and the old token in CAS will be cleaned up by the server itself after
    // a timeout has expired.

    // MU - This is now dealt with by storing data in session storage.
    // this.authHttp.deleteToken(); 
  }

  name: string;             // Top left
  title: string;            // Top left after hyphen
  footer: string;           // Bottom left
  copyright: string;        // Bottom right
  displayFooter: boolean;   // Some views may not have enough space for the footer.
  displayMenu: boolean;
  displayBack: boolean;
  displayHeader: boolean;

  aboutMe: HomeCardModel;
  contact: HomeCardModel;
  logout: HomeCardModel;
  myBirthPlan: HomeCardModel;
  myNotes: HomeCardModel;
  myPregnancyAndMe: HomeCardModel;

  // Deps, shell update service to inject
  constructor(private shellUpdateService: ShellUpdateService, private authHttp: AuthHttpClient,
    public appConfig: AppConfigService, public userSessionService: UserSessionService,
    private breakpointObserver: BreakpointObserver, private homeCardService: HomeCardService) {
  }


  ngOnInit() {

    this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.appConfig.IsMobile = result.matches;
    });

    // Textual updates to the shell
    this.shellUpdateService.ShellMessage.subscribe((message) => {
      this.updateShell(message);
    });

    // Actions to apply to the shell
    this.shellUpdateService.ShellAction.subscribe((action) => {
      this.updateShellAction(action);
    });

    console.log("Loading Home Cards");
    this.homeCardService.loadHomeCards();
    this.homeCardService.cardsReady.subscribe(x => {
      console.log("Finding Home Cards");
      this.aboutMe = this.userSessionService.homeCards.find(x => x.CardName === 'AboutMe');
      this.contact = this.userSessionService.homeCards.find(x => x.CardName === 'Contact');
      this.logout = this.userSessionService.homeCards.find(x => x.CardName === 'Logout');
      this.myBirthPlan = this.userSessionService.homeCards.find(x => x.CardName === 'MyBirthPlan');
      this.myPregnancyAndMe = this.userSessionService.homeCards.find(x => x.CardName === 'MyPregnancyAndMe');
      this.myNotes = this.userSessionService.homeCards.find(x => x.CardName === 'MyNotes');
    });
  }

  // Update the shell with the shellMessage received from child components.
  // Used to update header and footer texts. These are Messages.
  updateShell(message: ShellUpdateMessage) {

    // Avoid ExpressionChangedAfterItHasBeenCheckedError.
    setTimeout(() => {
      this.name = message.Name;
      this.title = message.Title;
      this.copyright = message.Copyright;
      this.footer = message.Footer;
    });
  }

  // Update the shell with the shellActionMessage received from child components.
  // Used to display menus, hide footers, etc. These are Actions.
  updateShellAction(message: ShellActionMessage) {
    setTimeout(() => {
      // Open the side menu if requested
      if (message.OpenSideMenu) {
        this.sideNav.open();
        return;
      }
      // Otherwise perform other shell updates
      this.displayFooter = message.DisplayFooter;
      this.displayBack = message.DisplayBack;
      this.displayMenu = message.DisplayMenu;
      this.displayBack = message.DisplayBack;
      this.displayHeader = message.DisplayHeader;
    });
  }

  // Clean up otherwise we could expose ourselves to memory leaks.
  ngOnDestroy() {
    this.shellUpdateService.ShellMessage.unsubscribe();
    this.shellUpdateService.ShellAction.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts